import React from 'react';
import { array, bool, func, object } from 'prop-types';

import { capitalize, isEmpty } from 'lodash';

import MaterialTable from 'material-table';
import CircularProgress from '@material-ui/core/CircularProgress';

import { getObjectType } from '../../helpers/bacnetObjectTypeConversion';

import BacnetInventoryTableRowMenu from './BacnetInventoryTableRowMenu';

import classes from './BacnetInventoryTable.module.css';

const BacnetInventoryTable = ({
    bacnetInventory,
    companyInfo,
    loading,
    isFullHubAllowed,
    onInventoryToggle,
    setDevice,
    ...props
}) => {

    function handleInventoryToggle(event) {
        onInventoryToggle(event);
    }

    function renderMenu(rowData) {
        return (
            <BacnetInventoryTableRowMenu
                device={rowData}
                companyInfo={companyInfo}
                hidden={!isFullHubAllowed}
                setDevice={setDevice}
            />
        );
    }

    function renderCell(rowData, text) {
        return (
            <span
                className={rowData.isCreated ? classes.created : ''}
            >
                {text}
            </span>
        );
    }

    return (
        <div className={classes.BacnetInventoryTable} >
            {!bacnetInventory ?
                <div className={classes.loader}>
                    <CircularProgress size={50} />
                </div>
                :
                <div className={classes.tableWrapper}>
                    <MaterialTable
                        options={{
                            paging:    false,
                            showTitle: false,
                            search:    false,
                            selection: true,
                            toolbar:   false
                        }}
                        columns={[
                            {
                                title:  'Name',
                                field:  'DeviceName',
                                render: rowData => renderCell(rowData, rowData.DeviceName)
                            },
                            {
                                title:  'Model',
                                field:  'ModelName',
                                render: rowData => renderCell(rowData, rowData.ModelName)
                            },
                            {
                                title:  'Device ID',
                                field:  'DeviceId',
                                render: rowData => renderCell(rowData, rowData.DeviceId)
                            },
                            {
                                title:  'MAC',
                                field:  'MAC',
                                render: rowData => renderCell(rowData, rowData.MAC)
                            },
                            {
                                title:  'Profile',
                                field:  'profileName',
                                render: rowData => renderCell(rowData, rowData.profileName)
                            },
                            {
                                title:  '',
                                render: rowData => renderMenu(rowData)
                            }
                        ]}
                        data={bacnetInventory}
                        onSelectionChange={handleInventoryToggle}
                        detailPanel={rowData => {
                            return (
                                <div className={classes.subTable}>
                                    <MaterialTable
                                        options={{
                                            paging:    false,
                                            showTitle: false,
                                            search:    false,
                                            selection: false,
                                            toolbar:   false
                                        }}
                                        columns={[
                                            { title: 'Name', field: 'ObjectName' },
                                            { title: 'Description', field: 'Description' },
                                            {
                                                title:  'Data Type',
                                                field:  'dataType',
                                                render: rowData => !isEmpty(rowData.dataType) ? capitalize(rowData.dataType) : ''
                                            },
                                            {
                                                title:  'Object Type',
                                                field:  'ObjectType',
                                                render: rowData => getObjectType(rowData.ObjectType)
                                            },
                                            { title: 'Object Instance', field: 'ObjectInstance' },
                                            { title: 'Property ID', field: 'PropertyID' },
                                            {
                                                title:  'Array Index',
                                                field:  'ArrayIndex',
                                                render: rowData => rowData.ArrayIndex === -1 ? '-' : rowData.ArrayIndex
                                            },
                                            { title: 'Object Value', field: 'ObjectValue' }
                                        ]}
                                        data={rowData.items}
                                    />
                                </div>
                            );
                        }}
                    />
                </div>
            }
        </div>
    );
};

BacnetInventoryTable.defaultProps = {
    bacnetInventory:  [],
    isFullHubAllowed: true,
    onSort:           () => {}
};

BacnetInventoryTable.propTypes = {
    bacnetInventory:  array,
    companyInfo:      object,
    isFullHubAllowed: bool,
    onSort:           func
};

export default BacnetInventoryTable;
